<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">

        <div class="row">
            <div class="col-md-12">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Gestão de Categorias</h1>
                        <p class="welcome-message">
                            <button mat-icon-button routerLink="/cadastros/categorias">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Organize a hierarquia de categorias e subcategorias.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        @if (isLoading) {
        <div class="row">
            <div class="col-12 mb-4">
                <div class="row">
                    <div class="col-12 mb-3">
                        <app-loading-box [height]="'56'"></app-loading-box>
                    </div>
                </div>
                <app-loading-box [height]="'250'" [margin]="'20px 0 0 0'"></app-loading-box>
            </div>
        </div>
        } @else {

        <div class="section-container tree-section">
            <div class="tree-header">
                <span class="section-title tree-section-title">
                    <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
                    Hierarquia de categorias
                </span>
            </div>

            <div class="tree-container">
                <ng-container *ngTemplateOutlet="nodeList; context: { $implicit: treeNodes, level: 0 }"></ng-container>
            </div>
        </div>

        <!-- Recursive tree node template -->
        <ng-template #nodeList let-nodes let-level="level" let-isLast="isLast">
            @for (node of nodes; track node._tempId; let last = $last) {
            <div class="tree-node-wrapper" [class.tree-node-last]="last">
                <div class="tree-node-row" [class.tree-node-highlighted]="isHighlighted(node)">

                    <!-- Expand/Collapse toggle -->
                    @if (node.filhos.length > 0) {
                    <mat-icon class="material-symbols-outlined tree-expand-icon" (click)="toggleExpand(node)">
                        {{ node.isExpanded ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                    } @else {
                    <span class="tree-expand-spacer"></span>
                    }

                    <!-- Node icon -->
                    <mat-icon class="material-symbols-outlined tree-node-icon">
                        {{ node.filhos.length > 0 ? 'folder' : 'label' }}
                    </mat-icon>

                    <!-- Inline editing or label -->
                    @if (node.isEditing) {
                    <input class="tree-inline-input" [(ngModel)]="node.nome" [ngModelOptions]="{ standalone: true }"
                        [placeholder]="level === 0 ? 'Nome da categoria...' : 'Nome da subcategoria...'"
                        (keydown)="onKeydown($event, node)" (blur)="confirmarEdicao(node)" autofocus />
                    } @else {
                    <span class="tree-node-label">{{ node.nome }}</span>
                    @if (isHighlighted(node)) {
                    <span class="tree-node-badge">editando</span>
                    }
                    }

                    <!-- Action buttons -->
                    <div class="tree-node-actions">
                        @if (!node.isEditing) {
                        <button mat-icon-button type="button" (click)="adicionarSubcategoria(node)"
                            title="Adicionar subcategoria" class="tree-action-btn">
                            <mat-icon class="material-symbols-outlined">add</mat-icon>
                        </button>
                        <button mat-icon-button type="button" (click)="editarNode(node)" title="Editar nome"
                            class="tree-action-btn">
                            <mat-icon class="material-symbols-outlined">edit</mat-icon>
                        </button>
                        @if (level > 0) {
                        <button mat-icon-button type="button" (click)="excluirNode(node)" title="Excluir"
                            class="tree-action-btn tree-action-delete">
                            <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        </button>
                        }
                        } @else {
                        <button mat-icon-button type="button" (click)="confirmarEdicao(node)"
                            (mousedown)="$event.preventDefault()" title="Confirmar"
                            class="tree-action-btn tree-action-confirm">
                            <mat-icon class="material-symbols-outlined">check</mat-icon>
                        </button>
                        <button mat-icon-button type="button" (click)="cancelarEdicao(node)"
                            (mousedown)="$event.preventDefault()" title="Cancelar" class="tree-action-btn">
                            <mat-icon class="material-symbols-outlined">close</mat-icon>
                        </button>
                        }
                    </div>
                </div>

                <!-- Recursive children (only if expanded) -->
                @if (node.filhos.length > 0 && node.isExpanded) {
                <div class="tree-children">
                    <ng-container
                        *ngTemplateOutlet="nodeList; context: { $implicit: node.filhos, level: level + 1 }"></ng-container>
                </div>
                }
            </div>
            }
        </ng-template>

        }
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" (cancelar)="cancelar()" (salvar)="salvar()"></app-footer-action>